export enum RecoverOptionEnum {
    Email = 1,
    Sms = 2,
}